import UnileverGif from '../assets/img/unileverIconAnimation.gif';

export default function UnileverAnimation() {
  return (
    <div style={{ maxWidth: '100px' }}>
      <img src={UnileverGif} alt="Loading..." style={{ maxWidth: 100 }} />
      {/* <h4 className="text-center">Loading...</h4> */}
    </div>
  );
}
